import { render, staticRenderFns } from "./GroupCreteCourse.vue?vue&type=template&id=4a0c31b2&scoped=true"
import script from "./GroupCreteCourse.vue?vue&type=script&lang=js"
export * from "./GroupCreteCourse.vue?vue&type=script&lang=js"
import style0 from "./GroupCreteCourse.vue?vue&type=style&index=0&id=4a0c31b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c31b2",
  null
  
)

export default component.exports